import React from 'react'
import { Dialog } from '@material-ui/core'

import AddSubscription from './AddSubscription'
import RemoveSubscription from './RemoveSubscription'

const DialogTeamSubscription = ({
  teamId,
  hasDefaultPaymentMethod,
  teamPaymentCollectionMethod,
  subscribe,
  canceled,
  totalMembers,
  isUpdatingSubscription,
  onSubmit,
  onClose,
}) => {
  return (
    <Dialog open fullWidth maxWidth="sm">
      {subscribe && (
        <AddSubscription
          teamId={teamId}
          hasDefaultPaymentMethod={hasDefaultPaymentMethod}
          teamPaymentCollectionMethod={teamPaymentCollectionMethod}
          canceled={canceled}
          totalMembers={totalMembers}
          submitting={isUpdatingSubscription}
          onConfirm={onSubmit}
          onClose={onClose}
        />
      )}
      {!subscribe && (
        <RemoveSubscription
          submitting={isUpdatingSubscription}
          onClose={onClose}
          onConfirm={onSubmit}
        />
      )}
    </Dialog>
  )
}

export default DialogTeamSubscription
